import { VariableType } from '@iotize/tap/service/impl/variable';

import { ByteOrder16Bits, ByteOrder32Bits } from '../definitions';
import { toEnumFromValue } from '../util';
import { IotizeBundleModel } from './iotize-bundle-model';
import { IotizeConfigModel } from './iotize-config-model';

export class IotizeVariableModel {
  public data: any;
  public iotizeModule: IotizeConfigModel;
  public _bundle?: IotizeBundleModel;

  constructor(
    data: any,
    iotizeModule: IotizeConfigModel,
    bundle?: IotizeBundleModel,
  ) {
    this.data = data;
    this.iotizeModule = iotizeModule;
    if (bundle) {
      this._bundle = bundle;
    }
  }

  public toJson() {
    return this.data;
  }

  public module(): IotizeConfigModel {
    return this.iotizeModule;
  }

  /**
   * Size (int bits) of one element
   */
  public valueSize(): 1 | 8 | 16 | 32 {
    return IotizeVariableModel.unitSizeToBitSize(parseInt(this.data.$.Unit));
  }

  public valueQuantity(): number {
    return Number(this.data.$.Quantity);
  }

  public name(): string {
    return this.data.$.GUI_Name;
  }

  public id(): string {
    return this.data.$.Id;
  }

  public alias(): string {
    return this.data.$.GUI_Alias;
  }

  public description(): string {
    return this.data.$.GUI_Description;
  }

  public unit(): string {
    return this.data.$.GUI_DispUnit;
  }

  public bundle(): IotizeBundleModel | undefined {
    return this._bundle;
  }

  // public type(): VariableType.Data {
  //     if (this.data.$.GUI_float && this.data.$.GUI_float == 1) {
  //         return VariableType.Data.FLOAT32;
  //     } else if (this.data.$.GUI_unsigned && this.data.$.GUI_unsigned == 1) {
  //         return VariableType.Data.UINT32;
  //     } else {
  //         return VariableType.Data.INT32;
  //     }
  // }

  public dataType(): VariableType.Data {
    const unit = parseInt(this.data.$.Unit, 10);
    if (this.data.$.GUI_float && this.data.$.GUI_float == 1) {
      return VariableType.Data.FLOAT32;
    } else if (this.data.$.GUI_unsigned && this.data.$.GUI_unsigned == 1) {
      switch (unit) {
        case 0:
          return VariableType.Data.BOOLEAN;
        case 1:
          return VariableType.Data.UINT8;
        case 2:
          return VariableType.Data.UINT16;
        case 3:
          return VariableType.Data.UINT32;
        default:
          throw new Error(
            `Invalid data size "${unit}" for variable ${this.name()}`,
          );
      }
    } else {
      switch (unit) {
        case 0:
          return VariableType.Data.BOOLEAN;
        case 1:
          return VariableType.Data.INT8;
        case 2:
          return VariableType.Data.INT16;
        case 3:
          return VariableType.Data.INT32;
        default:
          throw new Error(
            `Invalid data size "${unit}" for variable ${this.name()}`,
          );
      }
    }
  }

  /**
   * Return attribute by name
   */
  public attribute(name: string): string | undefined {
    return this.data.$[name];
  }

  public byteOrder(): ByteOrder32Bits | ByteOrder16Bits | undefined {
    let guiCoding = this.attribute('GUI_coding');
    if (guiCoding) {
      if (this.valueSize() === 16) {
        return toEnumFromValue(ByteOrder16Bits, guiCoding);
      } else if (this.valueSize() === 32) {
        return toEnumFromValue(ByteOrder32Bits, guiCoding);
      }
    }
    return undefined;
  }

  /**
   * Convert unit size found in configuration file into a number of bits
   */
  public static unitSizeToBitSize(unitSize: number): 1 | 8 | 16 | 32 {
    switch (unitSize) {
      case 0:
        return 1;
      case 1:
        return 8;
      case 2:
        return 16;
      case 3:
        return 32;
      default:
        throw new Error(`Invalid unit size: ${unitSize}`);
    }
  }
}
